export default {
  features: {
    uploadClientFile: {},
  },
};
